// extracted by css-extract-rspack-plugin
export default {"colorBoxBorder":"#c4c4c4","colorWhite":"#fff","colorClickable":"rgba(92, 52, 205, 1)","control":"segmented__control___wcozS","active":"segmented__active___qcoBc"};